import React, { ReactElement } from 'react';
import { Immutable } from '@wds/utils';
import { Button } from '@wds/button';
import { Box } from '@wds/box';
import { Link } from '@wds/link';
import { Sheet } from '@wds/sheet';
import { Typography } from '@wds/typography';
import useStyles from './useStyles';
import NotificationItem from './NotificationItem';

export type NotificationsSheetProps = Immutable<{
  showNotifications: boolean;
}> & {
  toggleNotifications(): void;
};

const NotificationsSheet = ({
  showNotifications,
  toggleNotifications,
}: NotificationsSheetProps): ReactElement => {
  const { notificationsContainer, notificationsList } = useStyles();

  return (
    <Sheet
      show={showNotifications}
      onClose={toggleNotifications}
      showCloseButton
    >
      <Sheet.Header header="Notifications" />
      <Sheet.Body padding={false}>
        <Box className={notificationsContainer}>
          <Box mx={4}>
            <Typography align="right">
              <Button size="sm" color="muted">
                Mark all as read
              </Button>
            </Typography>
          </Box>
          <ul className={notificationsList}>
            <NotificationItem date="Today" time="5 mintues ago">
              <>
                You received 24 new responses on{' '}
                <a href="#">Notification Preferences Survey</a>.
              </>
            </NotificationItem>
            <NotificationItem date="Yesterday" time="9:15 AM" read>
              <>
                You received <strong>new responses</strong> on{' '}
                <strong>3 active</strong> surveys. <br /> 15 new responses on{' '}
                <a href="#">Q1 2023 Employee Satisfaction</a>.<br /> 23 new
                responses on <a href="#">Q2 2023 Other Survey</a>.
              </>
            </NotificationItem>
          </ul>
          <Box mx={4} my={10}>
            <Typography align="center" component="p" color="darkMuted">
              That&apos;s all your notifications from the last 30 days.
            </Typography>
          </Box>
        </Box>
      </Sheet.Body>
      <Sheet.Footer align="left">
        <Link underline href="#">
          Share your feedback
        </Link>
      </Sheet.Footer>
    </Sheet>
  );
};

export default NotificationsSheet;
export { NotificationsSheet };
